(function ($, window, document, PageLoadedQueue) {
        window.PageLoadedQueue.addFunction(function() {

            jQuery.fn.annotations = function (options) {
                var $this = this;
                var defaults = {
                    url: 'https://shop.plandent.de/?standalone=Avency.Nwd.ShoppingLists:ShoppingCartAnnotations.Standalone'
                };

                //get Settings from Data attributes
                var data = $this.data();
                if (!data) {
                    return;
                }

                Object.keys(data).forEach(function (key) {
                    let newKey = key.replace(/annotation/, '');
                    if (newKey !== key) {
                        newKey = newKey.charAt(0).toLowerCase() + newKey.slice(1);
                        data[newKey] = data[key];
                    }
                    delete data[key];
                });
                // set Options
                var opts = $.extend({}, defaults, data, options);
                var getData = function (callable) {
                    $.ajax({
                        url: opts.url,
                        processData: true,
                        dataType: "html",
                        complete: function (response) {
                            let $productHtml = $(response.responseText);
                            $this.html('');
                            $this.append($productHtml);
                            callable($productHtml);
                        }
                    })
                };
                var showListItem = function (id) {
                    $this.find('li:has(#' + id + ')').css('display', 'list-item');
                };
                getData(function () {
                    scanDocument();
                });

                var scanDocument = function () {
                    var numbers = [];
                    $('.annotation-number').each(function () {
                        var number = $(this).data('annotation');
                        numbers.push(number);
                    });
                    numbers = uniqueArray(numbers);

                    $this.find('li').css('display', 'none');
                    showListItem('price-annotation');
                    showListItem('grundsatz');
                    numbers.forEach(function (element) {
                        showListItem('annotation-' + element);
                    })
                };

                function uniqueArray(a) {
                    function onlyUnique(value, index, self) {
                        return self.indexOf(value) === index;
                    }

                    return a.filter(onlyUnique);
                }

                scanDocument();
                $(document).on('update-annotations',function(){
                    scanDocument();
                })
            };
            $('.annotations-text').annotations();
        });
    }
)(jQuery, window, document, window.PageLoadedQueue);

